import React, { ReactNode } from 'react';

import { cn } from '../../libs/utils';

interface TopNavigationPaddingSaferProps {
  children: ReactNode;
  className?: string;
  paddingEnabled?: boolean;
}

export function TopNavigationSafer({ children, className, paddingEnabled = true, ...props }: TopNavigationPaddingSaferProps) {
  return (
    <div
      className={cn(
        {
          'pt-top-navigation': paddingEnabled,
          'pt-0': !paddingEnabled
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
